import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

interface SleepLatencyStatsProps {
  latest: number | 'N/A'
  average: number | 'N/A'
}

export function SleepLatencyStats({ latest, average }: SleepLatencyStatsProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <p className="text-sm font-medium text-gray-400">Latest</p>
          <p className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400">
            {latest === 'N/A' ? 'N/A' : `${latest}m`}
          </p>
        </div>
        <div className="h-px bg-gradient-to-r from-purple-500/20 to-blue-500/20" />
        <div className="space-y-2">
          <p className="text-sm font-medium text-gray-400">Average</p>
          <p className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400">
            {average === 'N/A' ? 'N/A' : `${average}m`}
          </p>
        </div>
      </div>
      
      <div className="rounded-lg bg-gray-800/50 p-3">
        <p className="text-xs text-gray-400">
          Sleep latency measures how long it takes your child to fall asleep after going to bed.
          Lower values indicate better sleep habits.
        </p>
      </div>
    </div>
  )
}
